import { useContext } from "react";
import KotharContext from "./context";

const useKothar = () => useContext(KotharContext);
export default useKothar;
